<script>
export default {
	props: {
		theme: String,
		href: {
			type: String,
			required: true,
		},
		text: {
			type: String,
			default: 'Læs mere',
		},
	},
	data() {
		return {
		};
	},
};
</script>

<template>
<a
	:href="href"
	:class="['ge-link', theme]">
	<span v-text="text"></span>
	<sky-svg name="wedge"></sky-svg>
</a>
</template>

<style src="./ge-link.scss"></style>



// WEBPACK FOOTER //
// ge-link.vue?61fd6444